import {AuthCreate, AuthResource} from '@/interfaces';
import {CrudApiAbstract} from '@/api/CrudApiAbstract';
import {ResourceType} from '@/enums';

export class AuthApi extends CrudApiAbstract<AuthResource, AuthCreate> {
  public constructor() {
    super(`${ResourceType.Auth}`);
  }
}
